import Radium from '@flipdish/radium';
import { sortBy } from 'lodash';
import * as React from 'react';
import { findDOMNode } from 'react-dom';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  Divider,
  Icon,
  PageTitle,
  SectionHeader,
  SectionHeaderIcon,
  SectionHeaderText
} from '../../../ui';
import { Track } from '../../analytics';
import * as Api from '../../Api';
import * as Data from '../../Data';
import * as Store from '../../Store';
import { Utilities } from '../../Utilities';
import LoadingPanel from '../LoadingPanel';
import { MainLayout } from '../MainLayout/MainLayout';
const tinycolor = require('tinycolor2');

interface DispatchProps {}

interface StateProps {
  AppConfig: Data.Async<Api.AppConfig>;
  Menus: Store.MenuData;
  Restaurants: Data.Async<Api.CollectionRestaurantSummary[]>;
  collectionRestaurants: Store.CollectionMap;
  LastRestaurantUrl: string;
  translate: any;
  AppDesignScheme: Api.AppDesignScheme;
  isDark: boolean;
}

type Props = DispatchProps & StateProps;

interface State {}

class CollectionList extends React.Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context);
  }

  public componentDidMount() {
    const { Restaurants, AppConfig } = this.props;

    const domNode = findDOMNode(this);
    if (domNode) {
      Utilities.ensureVisible(domNode);
    }

    if (
      Restaurants.status === 'success' &&
      AppConfig.status === 'success' &&
      !AppConfig.data.DisplayPickupRestaurantListScreen
    ) {
      const collectionRestaurants = Restaurants.data;

      if (collectionRestaurants.length > 0) {
        Utilities.navigateTo(
          '/restaurant/' +
            collectionRestaurants[0].VirtualRestaurantId +
            '/collection/' +
            collectionRestaurants[0].PhysicalRestaurantId
        );
      }
    }
  }

  public UNSAFE_componentWillReceiveProps(newProps) {
    const { Restaurants, AppConfig } = newProps;

    if (
      Restaurants.status === 'success' &&
      AppConfig.status === 'success' &&
      !AppConfig.data.DisplayPickupRestaurantListScreen
    ) {
      const collectionRestaurants = Restaurants.data;

      if (collectionRestaurants.length > 0) {
        Utilities.navigateTo(
          '/restaurant/' +
            collectionRestaurants[0].VirtualRestaurantId +
            '/collection/' +
            collectionRestaurants[0].PhysicalRestaurantId
        );
      }
    }
  }

  public urlFor = (r: Api.CollectionRestaurantSummary): string => {
    const menuUrl = r.MenuUrl;

    if (menuUrl) {
      const menu = this.props.Menus[menuUrl];

      if (menu && menu.status === 'success' && menu.data.ConcessionStores.length > 0) {
        return '/concession/' + r.VirtualRestaurantId + '/' + r.PhysicalRestaurantId;
      }
    }
    return '/restaurant/' + r.VirtualRestaurantId + '/collection/' + r.PhysicalRestaurantId;
  };

  public closedUntil = (r: Api.CollectionRestaurantDetail): JSX.Element | null => {
    const { translate, AppDesignScheme, isDark } = this.props;

    if (r.IsOpen) {
      return null;
    }

    let preOrder: string = '';
    if (r.AcceptPreOrders) {
      preOrder = translate('Preorder_only');
    }

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      secondary: {
        color: AppDesignScheme.Secondary
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      },
      tertiaryLight: {
        color: tinycolor(AppDesignScheme.Tertiary)
          .lighten(15)
          .toString()
      },
      closed: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .setAlpha(0.2)
          .toString()
      },
      darkClosed: {
        borderColor: AppDesignScheme.Primary
      },
      borderSecondary: {
        borderColor: AppDesignScheme.Secondary
      }
    };

    return (
      <div
        className="delivery__restaurant__closed flex flex-align-center flex-justify-center"
        style={
          Radium.getState(this.state, `delivery-${r.PhysicalRestaurantId}`, ':active') ||
          Radium.getState(this.state, `delivery-${r.PhysicalRestaurantId}`, ':hover')
            ? styles.borderSecondary
            : isDark
            ? styles.darkClosed
            : styles.closed
        }
      >
        <i
          className="tertiary-light icon_info"
          style={
            Radium.getState(this.state, `delivery-${r.PhysicalRestaurantId}`, ':active') ||
            Radium.getState(this.state, `delivery-${r.PhysicalRestaurantId}`, ':hover')
              ? styles.secondary
              : isDark
              ? styles.primary
              : styles.tertiaryLight
          }
          aria-hidden="true"
        />
        <div className="delivery__restaurant__info">
          <p
            className="tertiary clear-margins fd-h4"
            style={
              Radium.getState(this.state, `delivery-${r.PhysicalRestaurantId}`, ':active') ||
              Radium.getState(this.state, `delivery-${r.PhysicalRestaurantId}`, ':hover')
                ? styles.secondary
                : isDark
                ? styles.primary
                : styles.tertiary
            }
          >
            {r.OpenTimeMessage}
          </p>
          {preOrder ? (
            <p
              className="tertiary clear-margins fd-h4"
              style={
                Radium.getState(this.state, `delivery-${r.PhysicalRestaurantId}`, ':active') ||
                Radium.getState(this.state, `delivery-${r.PhysicalRestaurantId}`, ':hover')
                  ? styles.secondary
                  : isDark
                  ? styles.primary
                  : styles.tertiary
              }
            >
              {preOrder}
            </p>
          ) : null}
        </div>
      </div>
    );
  };

  public trackSelectStore = (storeName: string): any => {
    Track('Restaurants', 'Store Selected', { eventLabel: storeName });
  };

  public restaurantButton = (r: Api.CollectionRestaurantSummary): JSX.Element => {
    const { AppDesignScheme, isDark, collectionRestaurants } = this.props;

    let address = 'Loading';
    let closedNotice: JSX.Element | null = null;

    const detail = collectionRestaurants[r.PhysicalRestaurantId];

    if (detail && detail.status === 'success') {
      const { data } = detail;
      if (detail.data) {
        address = detail.data.PhysicalRestaurantAddress;
        closedNotice = this.closedUntil(data);
      }
    }

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      secondary: {
        color: AppDesignScheme.Secondary
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      },
      restaurant: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .setAlpha(0.2)
          .toString(),
        ':hover': {
          borderColor: AppDesignScheme.Secondary,
          boxShadow: `-2px 2px 9px -5px ${AppDesignScheme.Secondary}`,
          backgroundColor: tinycolor(AppDesignScheme.Primary)
            .darken(3)
            .toString()
        },
        ':active': {
          borderColor: AppDesignScheme.Secondary,
          boxShadow: `-2px 2px 9px -5px ${AppDesignScheme.Secondary}`,
          backgroundColor: tinycolor(AppDesignScheme.Tertiary)
            .setAlpha(0.1)
            .toString()
        }
      },
      darkRestaurant: {
        borderColor: AppDesignScheme.Primary,
        ':hover': {
          background: 'transparent',
          borderColor: AppDesignScheme.Secondary,
          boxShadow: 'none'
        },
        ':active': {
          background: tinycolor(AppDesignScheme.Tertiary)
            .lighten(10)
            .toString(),
          borderColor: AppDesignScheme.Secondary,
          boxShadow: `-2px 2px 9px -5px ${AppDesignScheme.Secondary}`
        }
      }
    };

    return (
      <Link
        key={r.PhysicalRestaurantId}
        onClick={() => this.trackSelectStore(r.PhysicalRestaurantName)}
        to={this.urlFor(r)}
      >
        <div
          key={`delivery-${r.PhysicalRestaurantId}`}
          className="delivery__restaurant flex"
          style={isDark ? styles.darkRestaurant : styles.restaurant}
        >
          <div className="delivery__restaurant__details">
            <h3 className="clear-margins secondary" style={styles.secondary}>
              {r.PhysicalRestaurantName}
            </h3>
            <div className="flex flex-align-center delivery__restaurant__details__address">
              <i
                className="icon_pin secondary"
                aria-hidden="true"
                style={isDark ? styles.primary : styles.secondary}
              />
              {address && address != ' ' ? (
                <p
                  className="tertiary clear-margins fd-h4"
                  style={isDark ? styles.primary : styles.tertiary}
                >
                  {address}
                </p>
              ) : null}
            </div>
          </div>
          {closedNotice}
        </div>
      </Link>
    );
  };

  public backLink = (): JSX.Element | null => {
    const { AppConfig, translate, AppDesignScheme, isDark, LastRestaurantUrl } = this.props;
    if (AppConfig.status != 'success') {
      return null;
    }

    const styles = {
      nav: {
        ':hover': {},
        ':active': {}
      },
      secondaryActive: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      secondaryHover: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString()
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      },
      primary: {
        color: AppDesignScheme.Primary
      }
    };

    if (AppConfig.data.DeliveryEnabled) {
      return (
        <Link to="/where" data-fd="collection-back">
          <div key="fd-nav" className="fd-nav flex flex-align-center" style={styles.nav as any}>
            <i
              className="arrow_carrot-left tertiary"
              style={
                Radium.getState(this.state, 'fd-nav', ':active')
                  ? styles.secondaryActive
                  : Radium.getState(this.state, 'fd-nav', ':hover')
                  ? styles.secondaryHover
                  : isDark
                  ? styles.primary
                  : styles.tertiary
              }
              aria-hidden="true"
            />
            <p
              className="inline-block clear-margins tertiary bold"
              style={
                Radium.getState(this.state, 'fd-nav', ':active')
                  ? styles.secondaryActive
                  : Radium.getState(this.state, 'fd-nav', ':hover')
                  ? styles.secondaryHover
                  : isDark
                  ? styles.primary
                  : styles.tertiary
              }
            >
              <u>{translate('Back')}</u>
            </p>
          </div>
        </Link>
      );
    }
    if (LastRestaurantUrl !== '/') {
      return (
        <Link to={LastRestaurantUrl}>
          <div key="fd-nav" className="fd-nav flex flex-align-center" style={styles.nav as any}>
            <i
              className="arrow_carrot-left tertiary"
              style={
                Radium.getState(this.state, 'fd-nav', ':active')
                  ? styles.secondaryActive
                  : Radium.getState(this.state, 'fd-nav', ':hover')
                  ? styles.secondaryHover
                  : isDark
                  ? styles.primary
                  : styles.tertiary
              }
              aria-hidden="true"
            />
            <h3
              className="inline-block clear-margins tertiary bold"
              style={
                Radium.getState(this.state, 'fd-nav', ':active')
                  ? styles.secondaryActive
                  : Radium.getState(this.state, 'fd-nav', ':hover')
                  ? styles.secondaryHover
                  : isDark
                  ? styles.primary
                  : styles.tertiary
              }
            >
              <u>{translate('Menu')}</u>
            </h3>
          </div>
        </Link>
      );
    }
    return null;
  };

  public trackDelivery(): any {
    Track('Maps', 'Delivery Selected');
  }

  // TODO: refactor to MuiButton
  public renderDelivery(config: Api.AppConfig): JSX.Element | null {
    if (!config.DeliveryEnabled) {
      return null;
    }

    const { AppDesignScheme, isDark, translate } = this.props;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      secondary: {
        color: AppDesignScheme.Secondary
      },
      subheader: {
        borderColor: AppDesignScheme.Secondary,
        boxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`,
        backgroundColor: tinycolor(AppDesignScheme.Primary)
          .darken(3)
          .toString()
      },
      darkSubheader: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString(),
        backgroundColor: tinycolor(AppDesignScheme.Tertiary)
          .lighten(10)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${tinycolor(AppDesignScheme.Tertiary).darken(10)}`
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      },
      buttonPrimary: {
        backgroundColor: tinycolor(AppDesignScheme.Primary)
          .darken(3)
          .toString(),
        borderColor: AppDesignScheme.Secondary,
        ':hover': {
          borderColor: AppDesignScheme.Secondary
        },
        ':active': {},
        ':focus': {
          borderColor: AppDesignScheme.Secondary
        }
      },
      darkButtonPrimary: {
        backgroundColor: 'transparent',
        borderColor: AppDesignScheme.Primary,
        ':hover': {
          borderColor: AppDesignScheme.Secondary
        },
        ':active': {},
        ':focus': {
          borderColor: AppDesignScheme.Secondary
        }
      },
      buttonActive: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      buttonHover: {
        backgroundColor: AppDesignScheme.Secondary
      }
    };

    return (
      <div>
        <Link to="/delivery" onClick={this.trackDelivery}>
          <p className="tertiary bold fd-info" style={isDark ? styles.primary : styles.tertiary}>
            {translate('Order_for_delivery')}
          </p>
          <button
            className="fd-button fd-button--big fd-button--primary"
            key="delivery-button"
            style={
              [
                isDark ? styles.darkButtonPrimary : styles.buttonPrimary,
                Radium.getState(this.state, 'delivery-button', ':active')
                  ? styles.buttonActive
                  : Radium.getState(this.state, 'delivery-button', ':hover')
                  ? styles.buttonHover
                  : null
              ] as any
            }
            data-fd="collection-address-delivery"
          >
            <p
              className="clear-margins secondary"
              style={
                Radium.getState(this.state, 'delivery-button', ':hover') ||
                Radium.getState(this.state, 'delivery-button', ':active')
                  ? styles.primary
                  : isDark
                  ? styles.primary
                  : styles.secondary
              }
            >
              {translate('Select_an_address_for_delivery')}
            </p>
          </button>
        </Link>
      </div>
    );
  }

  public render(): JSX.Element {
    const {
      Restaurants,
      AppConfig,
      translate,
      AppDesignScheme,
      isDark,
      collectionRestaurants
    } = this.props;

    if (AppConfig.status != 'success' || Restaurants.status != 'success') {
      return <LoadingPanel AppDesignScheme={AppDesignScheme} isDark={isDark} />;
    }

    const ordered = sortBy(Restaurants.data, (r) => !r.IsOpen);

    const { Category } = AppConfig.data;

    let categoryNameTranslation = '';

    switch (Category) {
      case 0:
        categoryNameTranslation = 'Restaurant';
        break;
      case 1:
        categoryNameTranslation = 'Cafe';
        break;
      case 2:
        categoryNameTranslation = 'Store';
        break;
      default:
        categoryNameTranslation = 'Restaurant';
    }

    let groupedTableServiceDelivery = true;

    for (let r of ordered) {
      const detail = collectionRestaurants[r.PhysicalRestaurantId];

      if (detail && detail.status === 'success') {
        const { data } = detail;

        const tableServiceIndex =
          data.DeliveryType === Api.DeliveryType.Collection &&
          data.PickupLocationTypes.findIndex(
            (PickupLocation) => PickupLocation === Api.PickupLocationType.TableService
          );

        const isTableServiceOnly =
          data.DeliveryType === Api.DeliveryType.Collection &&
          data.PickupLocationTypes.length === 1 &&
          tableServiceIndex != -1;

        const TableServiceCategory =
          data.DeliveryType === Api.DeliveryType.Collection
            ? data.TableServiceCatagory || Api.TableServiceCategory.Generic
            : Api.TableServiceCategory.Generic;

        const TableServiceDelivery =
          (TableServiceCategory === Api.TableServiceCategory.Area ||
            TableServiceCategory === Api.TableServiceCategory.House ||
            TableServiceCategory === Api.TableServiceCategory.ParkingBay ||
            TableServiceCategory === Api.TableServiceCategory.Room ||
            TableServiceCategory === Api.TableServiceCategory.Villa) &&
          isTableServiceOnly;

        groupedTableServiceDelivery = groupedTableServiceDelivery && TableServiceDelivery;
      }
    }

    return (
      <MainLayout>
        <div className="container">
          <div className="row delivery">
            <div className="col-md-12">
              <div style={{ marginTop: '20px' }} />
              {this.backLink()}
            </div>
            <div className="col-lg-8 col-md-8 col-sm-12">
              <SectionHeader>
                <SectionHeaderIcon>
                  <Icon
                    fontSize="large"
                    aria-hidden
                    color="inherit"
                    className="fa fa-shopping-basket"
                  />
                </SectionHeaderIcon>

                <SectionHeaderText
                  id="skip-to-content"
                  title={
                    groupedTableServiceDelivery
                      ? translate('Delivery')
                      : AppConfig.data.DineInEnabled && !AppConfig.data.PickupEnabled
                      ? translate('Dine_in')
                      : AppConfig.data.DineInEnabled && AppConfig.data.PickupEnabled
                      ? `${translate('Collect')}/${translate('Dine_in')}`
                      : translate('Collection')
                  }
                  subTitle={translate('Select_a_restaurant', {
                    categoryName: translate(categoryNameTranslation)
                  })}
                />
              </SectionHeader>

              <div>{ordered.map(this.restaurantButton)}</div>

              <Divider />

              {AppConfig.data.DeliveryEnabled && (
                <SectionHeader>
                  <SectionHeaderIcon>
                    <Icon fontSize="large" aria-hidden color="inherit" className="ei icon_pin" />
                  </SectionHeaderIcon>

                  <SectionHeaderText title={translate('Delivery')} />
                </SectionHeader>
              )}
              {this.renderDelivery(AppConfig.data)}
            </div>
          </div>
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state: Store.State): StateProps => {
  return {
    Restaurants: state.flipdish.CollectionSummaries,
    AppConfig: state.flipdish.AppConfig,
    Menus: state.flipdish.MenuData,
    collectionRestaurants: state.collectionRestaurants,
    LastRestaurantUrl: state.flipdish.LastRestaurantUrl,
    translate: getTranslate(state.locale),
    AppDesignScheme: state.appDesignScheme,
    isDark: state.flipdish.isDark
  };
};

const mapDispatchToProps = (dispatch: any): DispatchProps => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Radium(CollectionList));
